"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filters = exports.AdvancedTab = exports.FiltersTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const Slider_1 = require("../../components/Slider");
const Filter_styles_1 = require("./Filter.styles");
function FiltersTab({ options, handleFilterValues, values, }) {
    return ((0, jsx_runtime_1.jsx)(Filter_styles_1.StyledFilterContainer, { children: options.map((option) => ((0, jsx_runtime_1.jsx)(Filter_styles_1.StyledFilterCard, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.ImageCard, { source: option.source, details: option.details, title: option.title, onClick: () => handleFilterValues(Object.assign(Object.assign({}, values), { type: option.value })) }) }, option.title))) }));
}
exports.FiltersTab = FiltersTab;
const AdvancedSection = ({ icon, text, sliders, values, handleFilterValues, }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Filter_styles_1.StyledFilterSubtitle, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: icon }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: text })] }), sliders.map((slider) => ((0, jsx_runtime_1.jsxs)(Filter_styles_1.StyledSliderContainer, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "Small", children: slider.title }), (0, jsx_runtime_1.jsx)(Slider_1.Slider, { value: values[slider.title], variant: "section", id: slider.id, title: slider.title, onUpdate: (updatedValue) => {
                        handleFilterValues(Object.assign(Object.assign({}, values), { [slider.title.toLowerCase()]: updatedValue }));
                    }, maxValue: slider.maxValue, minValue: slider.minValue })] }, slider.title)))] }));
function AdvancedTab({ inputValues, options, handleFilterValues, }) {
    return ((0, jsx_runtime_1.jsx)(Filter_styles_1.StyledTabsFilterContainer, { children: options.map((section, index, array) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AdvancedSection, Object.assign({}, section, { values: inputValues, handleFilterValues: handleFilterValues })), index !== array.length - 1 && (0, jsx_runtime_1.jsx)(ui_common_components_1.Divider, {})] }, section.text))) }));
}
exports.AdvancedTab = AdvancedTab;
function Filters({ advanced, filters, onUpdate }) {
    const [values, setValues] = (0, react_1.useState)({
        type: filters.selectedFilter,
        brightness: advanced.inputValues.brightness,
        contrast: advanced.inputValues.contrast,
        saturation: advanced.inputValues.saturation,
        vibrance: advanced.inputValues.vibrance,
        blur: advanced.inputValues.blur,
        vignette: advanced.inputValues.vignette,
    });
    const handleFilterValues = (0, react_1.useCallback)((data) => {
        setValues(() => (Object.assign(Object.assign({}, values), data)));
        onUpdate(data);
    }, [onUpdate, values]);
    return ((0, jsx_runtime_1.jsx)(ui_common_components_1.Tabs, { items: [
            {
                label: 'Filters',
                content: ((0, jsx_runtime_1.jsx)(FiltersTab, { options: filters.options, values: values, handleFilterValues: handleFilterValues })),
            },
            {
                label: advanced.label,
                content: ((0, jsx_runtime_1.jsx)(AdvancedTab, { options: advanced.options, inputValues: values, handleFilterValues: handleFilterValues })),
            },
        ] }));
}
exports.Filters = Filters;
//# sourceMappingURL=Filter.js.map